import { createReducer } from '@reduxjs/toolkit'

import { addTicket, preselectTicket, receivedTickets, removeTicket, requestTickets } from '../actions/actions'
import { prepareSerialTicketsForBooking } from '../utils/serialTickets'

export const initialState = { loading: false, tickets: [] }

const serialTickets = createReducer(initialState, {
  [requestTickets]: (state, { payload }) => {
    state.loading = true
    state.lastRequestPayload = payload
  },
  [receivedTickets]: (state, { payload: tickets }) => {
    state.loading = false
    state.tickets = prepareSerialTicketsForBooking(tickets, state.tickets)
  },
  [addTicket]: (state, { payload: { code } }) => {
    const ticket = state.tickets.find(ticket => ticket.code === code)
    if (ticket) ticket.count += 1
  },
  [removeTicket]: (state, { payload: { code } }) => {
    const ticket = state.tickets.find(ticket => ticket.code === code)
    if (ticket) ticket.count -= 1
  },
  [preselectTicket]: (state, { payload: { code, count } }) => {
    const ticket = state.tickets.find(ticket => ticket.code.toUpperCase() === code.toUpperCase())
    if (ticket) ticket.count = Math.min(Math.max(count, 1), ticket.maxCount)
  }
})

export default serialTickets
